module.exports = __webpack_public_path__ + "img/grid-1x2.6cf0b098.svg";